export const DEFAULT_MINIMUM_BOOKING_NOTICE_MINUTES = 180;
export const MAX_MINIMUM_BOOKING_NOTICE_MINUTES = 30 * 24 * 60;

export const resolveMinimumBookingNoticeMinutes = (value: unknown): number => {
  const resolvedValue = value ?? DEFAULT_MINIMUM_BOOKING_NOTICE_MINUTES;

  if (
    typeof resolvedValue !== 'number'
    || !Number.isSafeInteger(resolvedValue)
    || resolvedValue < 0
    || resolvedValue > MAX_MINIMUM_BOOKING_NOTICE_MINUTES
  ) {
    return DEFAULT_MINIMUM_BOOKING_NOTICE_MINUTES;
  }

  return resolvedValue;
};
